<div class="pl-0 file-component-list-file-row">
  @if (showGripHandle) {
    <div class="rv-sortable-handle focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-1 tw-rounded-sm" tabindex="0" role="button" [attr.aria-label]="'Drag handle for file ' + getFileName()">
      <streamline-icon
        aria-hidden="true"
        class="streamline-component-icon"
        name="sortableHandle"
        width="14"
        height="14">
      </streamline-icon>
    </div>
  }
  <div class="file-thumbnail">
    <div class="file-helper"></div>
    @if (entry.exists && !isStreamlineThumbnail()) {
      <img
        [src]="getThumbnailUrl()"
        [ngClass]="{ 'img-contain': isDefaultThumbnail() }"
        [attr.alt]="isDefaultThumbnail() ? '' : ('Thumbnail for ' + getFileName())">
      >
    }
    <div class="broken-link" [hidden]="entry.exists && !isStreamlineThumbnail()">
      <streamline-icon width="30" height="30"
        aria-hidden="true"
        name="{{ entry.exists ? getStreamlineIcon() : 'forbidden' }}"
      ></streamline-icon>
    </div>
  </div>
  <div class="file-entry" [ngClass]="{'is-error' : !entry.exists}">
    <div class="file-text">
      <div class="file-name" title="{{ getStoragePath() }}">{{getFileName()}}</div>
      <div class="file-error" [hidden]="entry.exists">
        Your {{fileType}} has been deleted, renamed, or moved.
      </div>
    </div>
    <div class="flex-row">
      @if (storageManagerService.isCanva(entry.file)) {
        <button mat-icon-button type="button" class="file-entry-action-button" title="Edit with Canva" aria-label="Edit with Canva" (click)="editWithCanva()">
          <streamline-icon class="streamline-component-icon" name="canva" width="16" height="16"></streamline-icon>
        </button>
      }
      <button mat-icon-button type="button" class="file-entry-action-button file-remove" title="Delete" aria-label="Delete" (click)="removeFileFromList()" >
        <streamline-icon class="streamline-component-icon" name="trash" width="16" height="16"></streamline-icon>
      </button>
    </div>
  </div>
</div>
